var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.photo)?_c('div',{staticClass:"centered-background-photo",style:(_vm.centeredPhotoStyles)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }